import AboutUs from "./AboutUs";
import "./LandingPage.css";
import Contact from "./Contact";
import Events from "./Events";
import Hero from "./Hero";
import Leadership from "./Leadership";
import Navbar from "./Navbar";
import PreConclave from "./PreConclave";
import React, { useState, useEffect } from "react";
import logo from "../../assets/LandingImages/logo_round.svg";

const LoadingEffect = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev < 100) {
          return prev + 2; // Adjust the increment for speed
        }
        clearInterval(interval);
        return prev;
      });
    }, 100); // Adjust the duration of each increment

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-container">
      <div className="ring">
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          className="center-svg"
        >
          <defs>
            <mask id="mask" x="0" y="0" width="100" height="100">
              <rect width="100" height="100" fill="white" />
              <circle cx="50" cy="50" r="45" fill="black" />
              <circle
                cx="50"
                cy="50"
                r="45"
                fill="white"
                style={{ stroke: "black", strokeWidth: "0" }}
              />
            </mask>
          </defs>
          <image
            href={logo}
            width="100"
            height="100"
            mask="url(#mask)"
            style={{
              clipPath: `inset(0 ${100 - progress}% 0 0)`,
              transition: "clip-path 0.1s linear",
            }}
          />
        </svg>

        <div className="bubbling-text">
          {Array.from("U D Y A M A 1 . 0").map((letter, index) => (
            <span key={index} style={{ animationDelay: `${0.15 * index}s` }}>
              {letter}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

function LandingPage() {
  const [loading, setLoading] = useState(true);

  // Check if the user has already visited
  useEffect(() => {
    const isVisited = localStorage.getItem("isVisited");
    if (isVisited) {
      setLoading(false); // Skip loading if they have visited before
    } else {
    // Show loading for the first visit
    const timer = setTimeout(() => {
      setLoading(false);
      localStorage.setItem("isVisited", "true"); // Mark the visit
    }, 5000); // Simulate a loading time of 5 seconds
    return () => clearTimeout(timer);
    }
  }, []);

  window.addEventListener('beforeunload', function () {
    // Clear the localStorage
    localStorage.removeItem('isVisited');});

  return (
    <>
      {loading ? (
        <LoadingEffect /> // Show the loading effect while loading is true
      ) : (
        <div className="App">
          <Navbar />
          <Hero />
          <div className="wrapper">
          <div className="px-2">
            <AboutUs />
          </div>
            <Events />
            <Leadership />
            <PreConclave />
          </div>
          <Contact />
        </div>
      )}
    </>
  );
}

export default LandingPage;
